import { render, staticRenderFns } from "./inviteLink.vue?vue&type=template&id=1c08a458"
import script from "./inviteLink.vue?vue&type=script&lang=js"
export * from "./inviteLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports